<div class="learning-development-container">
  <div class="header">
    <div class="title">
      <h3>{{title}}</h3>
    </div>
    <div class="search-bar-container">
      <div class="search-child">
        <emerald-input
          [label]="searchLabel"
          [trailingIcon]="'search'"
          [outlined]="true"
          (keyup)="onSearchChange($event)"
          [value]="filterValue"
        ><emerald-icon
          *ngIf="filterValue?.length && filterValue.length > 0"
          [icon]="'close'"
          (click)="clearInput()"
        ></emerald-icon>
        </emerald-input>
      </div>
    </div>
  </div>


  <!-- Error State -->
  <div *ngIf="errorMessage" class="error-container">
    <div class="error-message">
      <i class="material-icons">error</i>
      <span>{{errorMessage}}</span>
    </div>
  </div>

  <!-- Data Table -->
  <ng-container *ngIf="!isLoading && !errorMessage">
    <ng-container *ngIf="filteredContractors?.length; else noDataTemplate">
      <emerald-datatable
        [columnDefs]="columnDefs"
        [rowData]="filteredContractors"
        [paginationParams]="paginationParams"
        [maxHeight]="tableMaxHeight"
        class="contractor-table"
      >
      </emerald-datatable>
    </ng-container>
  </ng-container>

  <!-- No Data Template -->
  <ng-template #noDataTemplate>
    <div class="empty-state">
      <div class="empty-state-content">
        <img [src]="imageSrc" [alt]="noDataAltText" class="empty-state-image">
        <h2 class="empty-state-title">{{noDataMessage}}</h2>
      </div>
    </div>
  </ng-template>
</div>
